module.exports = __webpack_public_path__ + "static/media/Owasp.9f19e6a2.png";